// src/components/Header.js
import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Database } from 'lucide-react';
import { useAuth } from "../context/Authcontext";
const Header = () => {
  const location = useLocation();
  const sections = ['#features', '#how-it-works', '#pricing', '#contact'];
  const {isAuthenticated,logout }= useAuth();
  const handleLogout = ()=>{
    logout();
  }
  return (
    <header className="bg-white bg-opacity-70 shadow-sm border-b fixed w-full z-10 animate-fadeIn backdrop-blur-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
        <div  className="flex items-center">
          <Link to= "/" className="w-10 h-10 rounded-full mr-3 overflow-hidden flex items-center justify-center bg-blue-600">
          
          <img src="/logo.jpg" alt="Logo" className="w-full h-full object-cover" />
          </Link>
          <Link to="/" className="text-xl font-bold text-gray-900">
          <span>DealGrid</span>
          </Link>
          </div>
          <nav className="hidden md:flex space-x-8">
            {sections.map((section) => (
              <Link
                key={section}
                to={section}
                className={`text-gray-600 hover:text-blue-600 transition-colors ${location.hash === section ? 'text-blue-600' : ''}`}
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector(section)?.scrollIntoView({ behavior: 'smooth' });
                }}
              >
                {section === '#features' && 'Features'}
                {section === '#how-it-works' && 'How It Works'}
                {section === '#pricing' && 'Pricing'}
                {section === '#contact' && 'Contact'}
              </Link>
            ))}
          </nav>
          <div className="flex space-x-4">
            {/* <Link to="/login" className="bg-gray-200 text-blue-600 px-6 py-2 rounded-lg hover:bg-gray-300 hover:scale-105 transition-transform">
              Log In
            </Link> */}

            {
                isAuthenticated ? (
                  <Link to="/datastats" className="bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 hover:scale-105 transition-transform">
                  Get Started
                </Link>
                ) : (
                  <Link to="/signup" className="bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 hover:scale-105 transition-transform">
                  Get Started
                </Link>
                )
              }
              {
                isAuthenticated ? (
                  <button
                    onClick={handleLogout}
                    className="bg-gray-200 text-red-600 px-6 py-2 rounded-lg hover:bg-gray-300 hover:scale-105 transition-transform"
                  >
                    Log Out
                  </button>
                ) : (
                  <Link
                    to="/login"
                    className="bg-gray-200 text-blue-600 px-6 py-2 rounded-lg hover:bg-gray-300 hover:scale-105 transition-transform"
                  >
                    Log In
                  </Link>
                )
              }

          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;